import { Box, Stack } from '@mui/joy';
import Sidebar from './Sidebar';
import Header from './Header';
import { Outlet, useNavigate } from 'react-router';
import { useEffect } from 'react';
import useUser from './auth/useUser';
import LargeLoader from './LargeLoader';
import NavBreadcrumbs from './NavBreadcrumbs';
import { useIntercom } from './useIntercom';
import OnboardingTour from './onboarding/OnboardingTour';

const MainLayout = ({ children }) => {
  const { user, loading: userLoading } = useUser();
  const isAdminPage = window.location.pathname.startsWith("/admin");
  useIntercom(isAdminPage ? null : user);
  const navigate = useNavigate();

  useEffect(() => {
    if (userLoading)
      return;
    if (user) {
      console.log("[MAIN LAYOUT] got user", user);
      if (!user.emailConfirmed) {
        navigate("/confirm-email");
      }
    } else {
      console.log("No user data");
      navigate("/sign-in");
    }
  }, [user, navigate, userLoading]);

  // useEffect(() => {
  //   // console.log("[MAIN LAYOUT] Initializing HubSpot widget", window.HubSpotConversations);
  //   let timeout = null;
  //   const initHubSpot = () => {
  //     const widget = window.HubSpotConversations?.widget;
  //     if (!widget) {
  //       // console.log("HubSpot widget not initialized");
  //       timeout = setTimeout(initHubSpot, 200);
  //       return;
  //     }
  //     const status = widget.status();
  //     if (!status.loaded) {
  //       // console.log("HubSpot widget not loaded yet");
  //       timeout = setTimeout(initHubSpot, 200);
  //       return;
  //     }
  //     // console.log("HubSpot widget initialized", widget);
  //     // console.log("HubSpot widget state", widget.status());
  //     widget.close();
  //     if (isAdminPage)
  //       widget.remove();
  //     // widget.refresh();
  //   }
  //   initHubSpot();
  //   return () => {
  //     if (timeout) {
  //       clearTimeout(timeout);
  //     }
  //   }
  // }, [isAdminPage]);

  const hideBreadcrumbs = !user?.client || window.location.pathname.startsWith("/company/");

  return (
    <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
      {!user ? <LargeLoader /> :
        <OnboardingTour user={user}>
          <Sidebar user={user} />
          <Header />
          <Box
            component="main"
            className="MainContent"
            sx={{
              // pt: isAdminPage ? 0 : { xs: 'calc(12px + var(--Header-height))', md: 3 },
              pt: 0,
              pb: isAdminPage ? 0 : { xs: 2, sm: 2, md: 3 },
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minWidth: 0,
              height: '100dvh',
              gap: 1,
              overflow: 'auto',
            }}
          >
            <Box sx={{ flex: 1, width: '100%' }}>
              <Stack
                spacing={2}
                sx={{
                  display: 'flex',
                  maxWidth: isAdminPage ? "100%" : '800px',
                  mx: 'auto',
                  px: isAdminPage ? 0 : { xs: 2, md: 6 },
                  py: isAdminPage ? 0 : { xs: 2, md: 3 },
                  pt: 0,
                }}
              >
                {!isAdminPage && (!hideBreadcrumbs ? <NavBreadcrumbs /> : <Box sx={{ mb: "16px !important" }} />)}
                {children}
                <Outlet />
              </Stack>
            </Box>
          </Box>
        </OnboardingTour>
      }
    </Box>
  );
}

export default MainLayout;